import React from "react";
import { Search, X } from "lucide-react";
import "./FilterBar.css";

function FilterBar({
    search,
    onSearchChange,
    searchPlaceholder = "Search…",
    hideSearch = false,
    chips,
    onChipToggle,
    extra,
}) {
    return (
        <div className="filter-bar">
            {!hideSearch && (
                <div className="filter-bar__search">
                    <Search size={14} aria-hidden="true" className="filter-bar__icon" />
                    <input
                        type="search"
                        value={search ?? ""}
                        onChange={(e) => onSearchChange?.(e.target.value)}
                        placeholder={searchPlaceholder}
                        className="filter-bar__input focus-ring"
                        aria-label={searchPlaceholder}
                    />
                    {search && (
                        <button
                            type="button"
                            className="filter-bar__clear"
                            onClick={() => onSearchChange?.("")}
                            aria-label="Clear search"
                        >
                            <X size={12} aria-hidden="true" />
                        </button>
                    )}
                </div>
            )}
            {chips && chips.length > 0 && (
                <div className="filter-bar__chips" role="group" aria-label="Filters">
                    {chips.map((chip) => (
                        <button
                            type="button"
                            key={chip.key}
                            className={`filter-bar__chip focus-ring ${chip.active ? "is-active" : ""}`}
                            onClick={() => onChipToggle?.(chip.key)}
                            aria-pressed={chip.active}
                        >
                            {chip.label}
                        </button>
                    ))}
                </div>
            )}
            {extra && <div className="filter-bar__extra">{extra}</div>}
        </div>
    );
}

export default FilterBar;
